import { render } from "./StopMealList.vue?vue&type=template&id=27fac2e0&scoped=true"
import script from "./StopMealList.vue?vue&type=script&lang=js"
export * from "./StopMealList.vue?vue&type=script&lang=js"

import "./StopMealList.vue?vue&type=style&index=0&id=27fac2e0&scoped=true&lang=css"

import exportComponent from "E:\\H5\\order_food\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fac2e0"]])

export default __exports__